import React, { useEffect, useState } from "react";
import styled from "styled-components";
import NameSection from "./Information/NameSection";
import PersonalSection from "./Information/PersonalSection";
import AddressSection from "./Information/AddressSection";
const Wrapper = styled.div`
  .border-CK {
    border: 1px solid #d1d5db;
    border-radius: 12px;
    padding: 24px;
    position: relative;
  }
  .artist-image {
    width: 96px;
    height: 96px;
  }
  .color-1 {
    color: #1f2937;
  }
  /* Утсан дээр засах товчнууд контенттой давхцахгүйн тулд дээд талд зай гаргана */
  @media (max-width: 767px) {
    .border-CK {
      padding: 64px 16px 16px;
    }
  }
`;

const Information = ({
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  isUserCanEdit,
  oneRingRulesAll,
}) => {
  const [isPublisher, setIsPublisher] = useState(true);
  useEffect(() => {
    document.title = "MMusic - Профайл - Бүртгэлийн мэдээлэл";
  }, []);
  return (
    <Wrapper className="flex flex-col gap-4 px-3 py-4 md:px-6 md:py-8">
      <NameSection
        oneRingRulesAll={oneRingRulesAll}
        isUserCanEdit={isUserCanEdit}
        setCKPopup={setCKPopup}
        setCKPopupType={setCKPopupType}
        setCKPopupMessage={setCKPopupMessage}
      />
      <PersonalSection
        oneRingRulesAll={oneRingRulesAll}
        isUserCanEdit={isUserCanEdit}
        setCKPopup={setCKPopup}
        setCKPopupType={setCKPopupType}
        setCKPopupMessage={setCKPopupMessage}
      />
      <AddressSection
        oneRingRulesAll={oneRingRulesAll}
        isUserCanEdit={isUserCanEdit}
        setCKPopup={setCKPopup}
        setCKPopupType={setCKPopupType}
        setCKPopupMessage={setCKPopupMessage}
      />
    </Wrapper>
  );
};

export default Information;
